module.exports = __webpack_public_path__ + "static/media/diz108.3c5df558.jpg";